import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiHome, FiNavigation, FiMapPin, FiTruck, FiUsers, FiLogOut } from 'react-icons/fi';
import { MdHotel } from 'react-icons/md';

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <img src="/logo_wht.svg" alt="MTU Travel" style={{ width: '56%', maxWidth: 126 }} />
          <small>{user?.company_name}</small>
        </div>
        <nav className="sidebar-nav">
          <NavLink to="/" end><FiHome /> Genel Bakış</NavLink>
          <NavLink to="/flights"><FiNavigation /> Uçak Bileti</NavLink>
          <NavLink to="/hotels"><MdHotel /> Otel</NavLink>
          <NavLink to="/transfers"><FiMapPin /> Transfer</NavLink>
          <NavLink to="/carrentals"><FiTruck /> Araç Kiralama</NavLink>
          <NavLink to="/passengers"><FiUsers /> Yolcular</NavLink>
        </nav>
        <div className="sidebar-footer">
          <div style={{ fontSize: 13, marginBottom: 8, opacity: 0.8 }}>{user?.full_name}</div>
          <button onClick={handleLogout}><FiLogOut style={{ marginRight: 6 }} /> Çıkış Yap</button>
        </div>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
